// import React from "react";

// const DeleteMetaProfile = () => {
//   return (
//     <div>
//       <div className="min-h-screen bg-white">

//         {/* Main Content */}
//         <div className="max-w-3xl mx-auto px-4 ">
//           {/* Introduction */}

//           {/* How to Request */}
//           <div className="mb-10">
//             <h2 className="text-2xl font-bold text-slate-800 mb-4 border-b-3 border-blue-600 pb-2 inline-block">
//               How to Request Data Deletion
//             </h2>

//             <div className="bg-slate-50 rounded-lg p-6 border border-slate-200 mt-6">
//               <p className="text-gray-700 mb-4">
//                 You can request deletion of your data by emailing us at:
//               </p>

//               <div className="bg-white p-5 rounded-lg border-2 border-blue-600 mb-6 shadow-sm">
//                 <p className="text-sm text-gray-600 mb-1 font-medium">Email:</p>
//                 <a
//                   href="mailto:support@yapgen.com"
//                   className="text-xl font-bold text-blue-600 hover:text-blue-700 transition-colors"
//                 >
//                   support@yapgen.com
//                 </a>
//               </div>

//               <div>
//                 <p className="font-semibold text-slate-800 mb-3">
//                   Please include the following details in your request:
//                 </p>

//                 <ul className="space-y-2.5 text-gray-700">
//                   <li className="flex items-start">
//                     <span className="mr-3 mt-1.5 w-2 h-2 bg-blue-600 rounded-full flex-shrink-0"></span>
//                     <span>Your full name</span>
//                   </li>
//                   <li className="flex items-start">
//                     <span className="mr-3 mt-1.5 w-2 h-2 bg-blue-600 rounded-full flex-shrink-0"></span>
//                     <span>Your registered email or phone number</span>
//                   </li>
//                   <li className="flex items-start">
//                     <span className="mr-3 mt-1.5 w-2 h-2 bg-blue-600 rounded-full flex-shrink-0"></span>
//                     <span>Your Facebook User ID (if applicable)</span>
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>

//           {/* What Happens Next */}
//           <div className="mb-10">
//             <h2 className="text-2xl font-bold text-slate-800 mb-4 border-b-3 border-blue-600 pb-2 inline-block">
//               What Happens Next?
//             </h2>

//             <div className="bg-emerald-50 rounded-lg p-6 border-l-4 border-emerald-600 mt-6 shadow-sm">
//               <p className="text-gray-700 leading-relaxed">
//                 Once we receive your request, we will{" "}
//                 <strong className="text-emerald-700">
//                   delete all related data from our servers within 48 hours
//                 </strong>
//                 . You will receive a confirmation email once the deletion
//                 process is complete.
//               </p>
//             </div>
//           </div>

//           {/* Important Notice */}
//           <div className="mb-10">
//             <div className="bg-red-50 border-l-4 border-red-600 rounded-r-lg p-5 shadow-sm">
//               <p className="font-bold text-red-900 mb-3 flex items-center">
//                 <span className="text-xl mr-2">⚠️</span>
//                 Important Notice
//               </p>
//               <ul className="space-y-2 text-gray-700 text-sm">
//                 <li className="flex items-start">
//                   <span className="mr-3 mt-1.5 w-2 h-2 bg-red-600 rounded-full flex-shrink-0"></span>
//                   <span>
//                     Account deletion is permanent and cannot be undone
//                   </span>
//                 </li>
//                 <li className="flex items-start">
//                   <span className="mr-3 mt-1.5 w-2 h-2 bg-red-600 rounded-full flex-shrink-0"></span>
//                   <span>All your data will be permanently removed</span>
//                 </li>
//                 <li className="flex items-start">
//                   <span className="mr-3 mt-1.5 w-2 h-2 bg-red-600 rounded-full flex-shrink-0"></span>
//                   <span>
//                     Some data may be retained for legal compliance purposes
//                   </span>
//                 </li>
//               </ul>
//             </div>
//           </div>

//           {/* Contact Button */}
//           <div className="text-center">
//             <p className="text-gray-600 mb-4">
//               Have questions? Contact our support team.
//             </p>
//             <a
//               href="mailto:support@yapgen.com"
//               className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-3 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg"
//             >
//               Email Support
//             </a>
//           </div>

//           {/* Compliance Note */}
//           <div className="mt-12 pt-8 border-t border-gray-200">
//             <p className="text-center text-sm text-gray-500">
//               This page is provided to comply with Facebook User Data Deletion
//               requirements.
//             </p>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default DeleteMetaProfile;

// import React from "react";

// export default function DeleteMetaProfile() {
//   return (
//     <div className="min-h-screen bg-white">
//       <div className="max-w-3xl mx-auto px-4 py-10">
//         <h1 className="text-3xl font-bold text-slate-900 mb-4 text-center">
//           Data Deletion Request
//         </h1>

//         <p className="text-center text-gray-700 mb-8 max-w-2xl mx-auto">
//           If you want to delete your account or personal data from our system,
//           please follow the steps below:
//         </p>

//         {/* How to Request */}
//         <div className="mb-10">
//           <h2 className="text-2xl font-bold text-slate-800 mb-4 border-b-4 border-blue-600 pb-2 inline-block">
//             How to Request Data Deletion
//           </h2>

//           <div className="bg-slate-50 rounded-lg p-6 border border-slate-200 mt-6">
//             <p className="text-gray-700 mb-4">
//               You can request deletion of your data by emailing us at:
//             </p>

//             <div className="bg-white p-5 rounded-lg border-2 border-blue-600 mb-6 shadow-sm">
//               <p className="text-sm text-gray-600 mb-1 font-medium">Email:</p>
//               <a
//                 href="mailto:support@yourdomain.com"
//                 className="text-xl font-bold text-blue-600 hover:text-blue-700 transition-colors"
//               >
//                 support@yourdomain.com
//               </a>
//             </div>

//             <div>
//               <p className="font-semibold text-slate-800 mb-3">
//                 Please include the following details:
//               </p>

//               <ul className="space-y-2.5 text-gray-700">
//                 <li className="flex items-start">
//                   <span className="mr-3 mt-1.5 w-2 h-2 bg-blue-600 rounded-full flex-shrink-0"></span>
//                   <span>Your full name</span>
//                 </li>
//                 <li className="flex items-start">
//                   <span className="mr-3 mt-1.5 w-2 h-2 bg-blue-600 rounded-full flex-shrink-0"></span>
//                   <span>Your registered email or phone number</span>
//                 </li>
//                 <li className="flex items-start">
//                   <span className="mr-3 mt-1.5 w-2 h-2 bg-blue-600 rounded-full flex-shrink-0"></span>
//                   <span>Your Facebook User ID</span>
//                 </li>
//               </ul>
//             </div>
//           </div>
//         </div>

//         {/* What Happens Next */}
//         <div className="mb-10">
//           <h2 className="text-2xl font-bold text-slate-800 mb-4 border-b-4 border-blue-600 pb-2 inline-block">
//             What Happens Next?
//           </h2>

//           <div className="bg-emerald-50 rounded-lg p-6 border-l-4 border-emerald-600 mt-6 shadow-sm">
//             <p className="text-gray-700 leading-relaxed">
//               Once we receive your request, we will{" "}
//               <strong className="text-emerald-700">
//                 delete all related data from our servers within 48 hours
//               </strong>
//               .
//             </p>
//           </div>
//         </div>

//         {/* Compliance */}
//         <div className="mt-12 pt-8 border-t border-gray-200">
//           <p className="text-center text-sm text-gray-500">
//             This page is provided to comply with Facebook User Data Deletion
//             requirements.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

import React from "react";

const DeleteMetaProfile = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-3xl mx-auto px-4 pt-8">
        <h1 className="text-3xl font-bold text-slate-900 mb-1 ">
          Data Deletion Request
        </h1>

        <p className=" text-gray-700 mb-8 ">
          We ensure that all your data is securely removed in accordance with
          our privacy and security policies.
        </p>

        {/* How to Request */}
        <div className="mb-10">
          <h2 className="text-2xl font-bold text-slate-800 mb inline-block">
            How to Request Data Deletion
          </h2>
          <div className=" md:w-32 w-20   h-1 bg-main1  rounded-full" />

          <div className="bg-slate-50 rounded-lg p-6 border border-slate-200 mt-6">
            <p className="text-gray-700 mb-4">
              You can request deletion of your data by emailing us at:
            </p>

            <div className="bg-white p-5 rounded-lg  mb-6 shadow-sm">
              <p className="text-sm text-gray-600 mb-1 font-medium">Email:</p>
              <a
                href="mailto:info@deetyasoft.com"
                className="text-xl font-bold text-blue-600 hover:text-blue-700 transition-colors"
              >
                info@deetyasoft.com
              </a>
            </div>

            <div>
              <p className="font-semibold text-slate-800 mb-3">
                Please include the following details:
              </p>

              <ul className="space-y-2.5 text-gray-700">
                <li className="flex items-start">
                  <span className="mr-3 mt-1.5 w-2 h-2 bg-blue-600 rounded-full flex-shrink-0"></span>
                  <span>Your full name</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 mt-1.5 w-2 h-2 bg-blue-600 rounded-full flex-shrink-0"></span>
                  <span>Your registered email or phone number</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 mt-1.5 w-2 h-2 bg-blue-600 rounded-full flex-shrink-0"></span>
                  <span>Your Facebook User ID</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* What Happens Next */}
        <div className="mb-10">
          <h2 className="text-2xl font-bold text-slate-800 mb-1 inline-block">
            What Happens Next?
          </h2>
          <div className=" md:w-32 w-20   h-1 bg-main1  rounded-full" />

          <div className="bg-emerald-50 rounded-lg p-6 border-l-4 border-emerald-600 mt-6 shadow-sm">
            <p className="text-gray-700 leading-relaxed">
              Once we receive your request, we will
              <strong className="text-emerald-700">
                {" "}
                delete all related data from our servers within 48 hours
              </strong>
              .
            </p>
          </div>
        </div>
        <div className="mb-10">
          <div className="bg-red-50 border-l-4 border-red-600 rounded-r-lg p-5 shadow-sm">
            <p className="font-bold text-red-900 mb-3 flex items-center">
              <span className="text-xl mr-2">⚠️</span>
              Important Notice
            </p>
            <ul className="space-y-2 text-gray-700 text-sm">
              <li className="flex items-start">
                <span className="mr-3 mt-1.5 w-2 h-2 bg-red-600 rounded-full flex-shrink-0"></span>
                <span>Account deletion is permanent and cannot be undone</span>
              </li>
              <li className="flex items-start">
                <span className="mr-3 mt-1.5 w-2 h-2 bg-red-600 rounded-full flex-shrink-0"></span>
                <span>All your data will be permanently removed</span>
              </li>
            
            </ul>
          </div>
        </div>
        {/* Support Button */}
        <div className="text-center mt-6">
          <a
            href="mailto:info@deetyasoft.com"
            className="inline-block bg-orangeheading text-white font-semibold px-8 py-3 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg"
          >
            Contact Support
          </a>

          <div className="mt-12 pt-8 border-t mb-10 border-gray-200">
            <div className=" p-4 rounded">
              <p className="text-sm text-gray-700 font-medium">
                <strong className=" text-red-500">Note:</strong> This page is
                provided to comply with Facebook User Data Deletion
                requirements.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteMetaProfile;
